export default __webpack_public_path__ + "c6f2f7e3ef0b87465da7b4bcec0bd716.png";